import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import Board from "@publicPortal/components/board/Board";
import SearchActions from "@publicPortal/pages/search/SearchActions";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import React, { memo, useCallback, useEffect, useState } from "react";
import UserCollectedDataHelper from "../../UserCollectedDataHelper";
import { EditSavedSearch } from "./PlanningApplicationEditSearch";
import { ValidationResult } from "@shared/mirage/validators";
import { IsStringNotEmptyValidator } from "@shared/mirage/validators/IsStringNotEmptyValidator";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";
import PublicPortalState from "@publicPortal/utils/InitialState";
import PropertySearchFields from "@publicPortal/pages/search/PropertySearch/PropertySearchFields";

const PropertySearchEditSearch: React.FC<EditSavedSearch> = memo(({ closeModal, criteria, isOpen, saveEditSearch }) => {
    const initialValues = criteria.jsonSearchParameters && JSON.parse(criteria.jsonSearchParameters);
    const { initialSearchState, initialFilterState } = PublicPortalState.propertySearch();
    const initSearchState: { filter: PropertySearchFilter } = {
        ...initialSearchState,
        filter: {
            ...initialFilterState,
            ...initialValues,
        },
    };
    const [state, setState] = useState<{ filter: PropertySearchFilter }>({ filter: {} as PropertySearchFilter });
    const [searchName, setSearchName] = useState("");
    const [searchNameValidation, setSearchNameValidation] = useState<ValidationResult>({ passed: true, error: "" });
    const handleSearchName = (value: string) => {
        const validationResult = IsStringNotEmptyValidator(value, "Enter Search name");
        setSearchNameValidation(validationResult);
        setSearchName(value);
    };
    const setStateModifier = useCallback(
        (modifier: Partial<PropertySearchFilter>) => {
            setState((prev) => {
                return { ...prev, filter: { ...prev.filter, ...modifier } };
            });
        },
        [setState]
    );

    useEffect(() => {
        setState(initSearchState);
        setSearchName(criteria.searchName);
        setSearchNameValidation({ passed: true, error: "" });
    }, [criteria, closeModal]);

    return (
        <>
            <Modal open={isOpen}>
                <Box height={"100%"}>
                    <Board id={"editSearch__bigBoard"} size={"big"}>
                        <Box className="editSearch__headerContainer">
                            {UserCollectedDataHelper.getSearchName(searchName, handleSearchName, searchNameValidation)}
                            <IconButton onClick={closeModal} className="close-saved-search-modal-button">
                                <FontAwesomeIcon icon={faXmark} style={PublicPortalTheme.icons.sizeM} />
                            </IconButton>
                        </Box>
                        <PropertySearchFields state={state.filter} setStateModifier={setStateModifier} />
                        <SearchActions onSubmitHandler={handleSave} onCancelHandler={closeModal} customSubmitName={"Save"} customCancelName={"Cancel"} />
                    </Board>
                </Box>
            </Modal>
        </>
    );

    async function handleSave() {
        if (searchNameValidation.passed) {
            await saveEditSearch(criteria.id, searchName, criteria.searchType, state.filter);
        }
    }
});

export default PropertySearchEditSearch;
